import { createTimeframedState } from 'reducers/globalReducer'
import { Timeframe } from 'interfaces/chart'
import { SET_MEMBER_GENERIC_TRENDS } from 'actions/genericActions'
import { GenericTrendType } from 'interfaces/pages'
import { Trend } from 'interfaces/trend'
import { needDiscardData, NETWORTH_PAGE_DISCARD_TRIGGERS, CREDIT_TREND_DISCARD_TRIGGERS } from 'helpers/discardTriggerHelpers'
import { Reducer } from 'interfaces'

export const createGenericTrendsReducer = (type: GenericTrendType) => {
  const triggers = type === 'networth' ? NETWORTH_PAGE_DISCARD_TRIGGERS : CREDIT_TREND_DISCARD_TRIGGERS

  const creator = (timeframe: Timeframe): Reducer<Trend | null> =>
    (state = null, action) => {
      if (needDiscardData(triggers)(action)) {
        return null
      }

      if (action.type === SET_MEMBER_GENERIC_TRENDS &&
          action.payload.type === type &&
          action.payload.timeframe === timeframe
      ) {
        return action.payload.data
      }

      return state
    }

  return createTimeframedState(creator)
}
